const s = {
  name: "Dino",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35.3,7c0,0.7-0.6,1.3-1.2,1.3c-0.7,0-1.2-0.6-1.2-1.3s0.6-1.2,1.2-1.2C34.7,5.8,35.3,6.3,35.3,7z"/>
		<path class="st0" d="M25,7.5V18c-4.1,0-8.1,1.4-11.2,4.1L11,24.4C8.2,26.7,4.6,28,1,28H0v1c0,2.8,2.2,5,5,5h2v6h12v-6h2v6h12v-7
			l0.5-18.1c3.7-0.5,6.5-3.6,6.5-7.4C40,3.4,36.6,0,32.5,0S25,3.4,25,7.5z M31,38h-3v-6H12v6H9v-6H5c-1.3,0-2.4-0.9-2.8-2
			c3.7-0.2,7.2-1.7,10.1-4l2.8-2.3c2.8-2.3,6.3-3.6,10-3.6h2V7.5c0-3,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5c0,3-2.5,5.5-5.5,5.5h-1
			L31,33V38z M26,34v4h-3v-4H26z M14,34h3v4h-3V34z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Dino
};
